import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import { ReactNode } from 'react';
import clsx from 'clsx';

import { OpTooltip } from '../OpTooltip/OpTooltip';

import './OpInfoTooltip.scss';

interface OpInfoTooltipProps {
  title: ReactNode;
  className?: string;
}

/**
 * OpInfoTooltip is a specialized tooltip component with a question mark icon trigger.
 * It displays helpful information when users hover over the question mark icon.
 * 
 * Use this component to provide contextual help, explanations, or additional information
 * about form fields, settings, or UI elements without cluttering the interface.
 * 
 * @example
 * <OpInfoTooltip title="This field is required for authentication" />
 * 
 */
export const OpInfoTooltip = ({ title, className }: OpInfoTooltipProps) => {
  return (
    <OpTooltip className={clsx('op-info-tooltip', className)} title={title}>
      <QuestionCircleOutlined className="op-info-tooltip__icon" />
    </OpTooltip>
  );
};
